import React from 'react'
import {
  Description as DescriptionIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  Warning as WarningIcon,
  Cancel as CancelIcon,
  HourglassEmpty as PendingIcon,
} from '@mui/icons-material'

export interface StatusConfig {
  color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  icon: React.ReactNode
  label: string
}

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  draft: { 
    color: 'default', 
    icon: <DescriptionIcon fontSize="small" />, 
    label: 'Draft' 
  },
  sent: { 
    color: 'info', 
    icon: <PendingIcon fontSize="small" />, 
    label: 'Sent' 
  },
  partially_paid: { 
    color: 'warning', 
    icon: <PendingIcon fontSize="small" />, 
    label: 'Partially Paid' 
  },
  paid: { 
    color: 'success', 
    icon: <CheckCircleIcon fontSize="small" />, 
    label: 'Paid' 
  },
  overdue: { 
    color: 'error', 
    icon: <WarningIcon fontSize="small" />, 
    label: 'Overdue' 
  },
  cancelled: { 
    color: 'error', 
    icon: <CancelIcon fontSize="small" />, 
    label: 'Cancelled' 
  },
}

export const getStatusConfig = (status: string): StatusConfig => {
  return STATUS_CONFIG[status] || { 
    color: 'default', 
    icon: <ScheduleIcon fontSize="small" />, 
    label: status 
  }
}
